export const AWARD_ICONS = {
  1: '/graphics/first-place-star.svg',
  2: '/graphics/second-place-star.svg',
  3: '/graphics/third-place-star.svg',
}
